import { ApiTypes } from "@agroyaar/sdk";
import {
  QUERY_KEYS_CROPPING_PATTERN,
  QUERY_KEYS_CROPPING_SUITABILITY,
  QUERY_KEYS_IRIIGATION_SOURCE,
  QUERY_KEYS_MECHANIZATION,
} from "./enum";

export const mechanizationQueryKeys = {
  varieties: (
    key: ApiTypes.Varieties["RequestParams"]["getAll"]["params"]["kindName"]
  ) => ["mechanization", "varieties", key] as const,

  mechanization: (
    pathParams: ApiTypes.Mechanization["RequestParams"]["getOne"]["pathParams"]
  ) => [QUERY_KEYS_MECHANIZATION.getMechanization, pathParams],

  mechanizations: (
    params: ApiTypes.Mechanization["RequestParams"]["getAll"]
  ) => [QUERY_KEYS_MECHANIZATION.getMechanizations, params],

  sensors: (params: ApiTypes.MechanizationSensor["RequestParams"]["getSensors"]) => [
    QUERY_KEYS_MECHANIZATION.getSensors,
    params,
  ],

  speedChanges: (
    params: ApiTypes.MechanizationSensor["RequestParams"]["getSpeedChange"]
  ) => [QUERY_KEYS_MECHANIZATION.getSpeedChangesChartData, params],

  movementChange: (
    params: ApiTypes.MechanizationSensor["RequestParams"]["getMovementChange"]
  ) => [QUERY_KEYS_MECHANIZATION.getMovementChanges, params],

  temperatureChanges: (
    params: ApiTypes.MechanizationSensor["RequestParams"]["getTemperatureChanges"]
  ) => [QUERY_KEYS_MECHANIZATION.getTemperatureChanges, params],

  fuelConsumptionChange: (
    params: ApiTypes.MechanizationSensor["RequestParams"]["getFuelConsumptionChanges"]
  ) => [QUERY_KEYS_MECHANIZATION.getFuelConsumptionChanges, params],
};

export const croppingPatternQueryKeys = {
  croppingPattern: (
    pathParams: ApiTypes.CroppingPattern["RequestParams"]["getOne"]["pathParams"]
  ) => [QUERY_KEYS_CROPPING_PATTERN.getOneCroppingPattern, pathParams],
};

export const croppingSuitabilityQueryKeys = {
  croppingSuitability: (
    pathParams: ApiTypes.CroppingSuitability["RequestParams"]["getOne"]["pathParams"]
  ) => [QUERY_KEYS_CROPPING_SUITABILITY.getOneCroppingSuitability, pathParams],
};

export const irrigationSourceQueryKeys = {
  irrigationSource: (
    pathParams: ApiTypes.IrrigationSource["RequestParams"]["getOne"]["pathParams"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getIrrigationSource, pathParams],

  irrigationSources: (
    params: ApiTypes.IrrigationSource["RequestParams"]["getAll"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getIrrigationSources, params],

  sensors: (params: ApiTypes.IrrigationSourceSensor["RequestParams"]["getSensors"]) => [
    QUERY_KEYS_IRIIGATION_SOURCE.getSensors,
    params,
  ],

  engineVibrationLevelChanges: (
    params: ApiTypes.IrrigationSourceSensor["RequestParams"]["getEngineVibrationLevelChanges"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getEngineVibrationLevelChangesData, params],

  statePowerChanges: (
    params: ApiTypes.IrrigationSourceSensor["RequestParams"]["getStatePowerChanges"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getStatePowerChangesData, params],

  statePumpChanges: (
    params: ApiTypes.IrrigationSourceSensor["RequestParams"]["getStatePumpChanges"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getStatePumpChagnesDate, params],

  consumptionAmpsChanges: (
    params: ApiTypes.IrrigationSourceSensor["RequestParams"]["getConsumptionAmpsChanges"]
  ) => [QUERY_KEYS_IRIIGATION_SOURCE.getConsumptionApmsChangesData, params],
};
